import { getLocalUserDetails } from 'Utils/LocalStorageHandler'

export const getUserRoleBasedFeature = () => {
  const userDetails = getLocalUserDetails()

  const rolesPermissions = [
    {
      roleId: 1,
      roleName: 'Super Admin',
      functionality: {
        newsFeed: { showAddButton: false, editNewsIconDisable: true, deleteNewsIconDisable: false, freeNewsToggleDisable: true, trendingNewsToggleDisable: true, languageDropdownDisable: false, filterDropdownDisable: false, isPreviewButtonDisabled: false, isRemarkButtonDisabled: false, isAdminPreviewButtonDisabled: false, approveRejectButtonDisabled: false },
        terminalDetails: { showAddButton: true, editTerminalDetailsButton: false, isActiveSwitchDisabled: false, filterDropDownDisabled: false, addTerminalDataButton: false },
        appSettings: { showDashboard: true },
        paymentReport: { showColumn: true }
      }
    },
    {
      roleId: 2,
      roleName: 'Admin',
      functionality: {
        newsFeed: { showAddButton: true, editNewsIconDisable: false, deleteNewsIconDisable: false, freeNewsToggleDisable: false, trendingNewsToggleDisable: false, languageDropdownDisable: false, filterDropdownDisable: false, isPreviewButtonDisabled: false, isRemarkButtonDisabled: false, isAdminPreviewButtonDisabled: false, approveRejectButtonDisabled: false },
        terminalDetails: { showAddButton: true, editTerminalDetailsButton: false, isActiveSwitchDisabled: false, filterDropDownDisabled: false, addTerminalDataButton: false }
      }
    },
    {
      roleId: 5,
      roleName: 'News Creator',
      functionality: {
        newsFeed: { showAddButton: true, editNewsIconDisable: false, deleteNewsIconDisable: true, trendingNewsToggleDisable: false, languageDropdownDisable: false, filterDropdownDisable: false, isPreviewButtonDisabled: false, isRemarkButtonDisabled: false, isAdminPreviewButtonDisabled: false, approveRejectButtonDisabled: true }
      }
    },
    {
      roleId: 10154,
      roleName: 'News Approver',
      functionality: {
        newsFeed: { showAddButton: false, editNewsIconDisable: true, deleteNewsIconDisable: false, freeNewsToggleDisable: true, trendingNewsToggleDisable: true, languageDropdownDisable: false, filterDropdownDisable: false, isPreviewButtonDisabled: false, isRemarkButtonDisabled: false, isAdminPreviewButtonDisabled: false, approveRejectButtonDisabled: false }
      }
    },
    {
      roleId: 10173,
      roleName: 'News Publisher',
      functionality: {
        newsFeed: { showAddButton: false, editNewsIconDisable: true, deleteNewsIconDisable: false, freeNewsToggleDisable: true, trendingNewsToggleDisable: true, languageDropdownDisable: false, filterDropdownDisable: false, isPreviewButtonDisabled: false, isRemarkButtonDisabled: false, isAdminPreviewButtonDisabled: false, approveRejectButtonDisabled: false }
      }
    },
    {
      roleId: 10158,
      roleName: 'Contract Creator',
      functionality: {
        terminalDetails: { showAddButton: true, editTerminalDetailsButton: false, isActiveSwitchDisabled: false, filterDropDownDisabled: false, addTerminalDataButton: true }
      }
    },
    {
      roleId: 10170,
      roleName: 'Terminal Data Creator',
      functionality: {
        terminalDetails: { showAddButton: false, editTerminalDetailsButton: true, isActiveSwitchDisabled: true, filterDropDownDisabled: false, addTerminalDataButton: false }
      }
    }
  ]

  const foundItem = rolesPermissions.find((item) => item?.roleId === userDetails?.userRole)

  return foundItem
}
